
import { Grid } from "@mui/material";

//Components
import { Spinner } from '@arredo/reactjs-ui';
import CustomerInfo from "./customer";
import InvoiceData from "./invoiceData";
import TaxInfo from "./taxInfo";
import PaymentMethods from "./paymentMethods";


const Invoice = ({ invoice: voucher, loading, title, voucherLabel }) => {
    return (
    <>
        {(!!loading || !voucher?.id) && 
        <> 
            <Grid container justifyContent='center'>
                <Spinner lockScreen message='Buscando Factura' />
            </Grid>
        </>
        }
        {!loading && voucher?.id &&
            <Grid container spacing={1}>
                <Grid size={12}>
                    {title}
                </Grid>
                <Grid size={6}>
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <InvoiceData invoice={voucher} title={`Datos de la ${voucherLabel}`} />
                        </Grid>
                        <Grid size={12}>
                            <TaxInfo voucher={voucher} />        
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={6}>
                    <Grid container spacing={1}>
                        <Grid size={12}>
                             <CustomerInfo customer={voucher?.customer} /> 
                        </Grid>
                        <Grid size={12}>
                            <PaymentMethods paymentMethods={voucher?.paymentMethods} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        }
    </>
    )
}   
export default Invoice;